export default "__VITE_ASSET__BGloV$oP__"